'use client'

import { useTranslations } from 'next-intl'
import { RefObject } from 'react'

import { Card } from '@/entities/contract'
import { SegmentedControl } from '@/shared/ui'

import { AccountPayment, Props as AccountPaymentProps } from './account'
import { CardPayment, Props as CardPaymentProps } from './card'
import { PaymentMethod, usePaymentMethod } from '../../model/payment'

export type Props = AccountPaymentProps &
  CardPaymentProps & {
    ref: RefObject<HTMLDivElement | null>
  }

export const Payment = ({
  payDeadlineTime,
  vaBankName,
  vaAccountHolder,
  vaAccount,
  roomName,
  startDate,
  endDate,
  finalPayFee,
  ref,
}: Props) => {
  const t = useTranslations()
  const { paymentMethod, isSelected, updatePaymentMethod } = usePaymentMethod()

  const handlePaymentMethodChange = (value: string) => {
    updatePaymentMethod(value)
  }

  return (
    <Card.Root spacing="large" ref={ref}>
      <Card.Item>
        <Card.ItemTitle>{t('lease_detail.make_payment.title')}</Card.ItemTitle>
        <Card.ItemContent className="space-y-6">
          <SegmentedControl.Root
            size="medium"
            type="single"
            value={paymentMethod}
            onValueChange={handlePaymentMethodChange}
          >
            <SegmentedControl.Item value={PaymentMethod.ACCOUNT}>
              {t('lease_detail.make_payment.button.method.bank_transfer')}
            </SegmentedControl.Item>
            <SegmentedControl.Item value={PaymentMethod.CARD}>
              {t('lease_detail.make_payment.button.method.card')}
            </SegmentedControl.Item>
          </SegmentedControl.Root>

          {isSelected(PaymentMethod.ACCOUNT) && (
            <AccountPayment
              payDeadlineTime={payDeadlineTime}
              vaBankName={vaBankName}
              vaAccountHolder={vaAccountHolder}
              vaAccount={vaAccount}
              finalPayFee={finalPayFee}
            />
          )}

          {isSelected(PaymentMethod.CARD) && (
            <CardPayment
              payDeadlineTime={payDeadlineTime}
              finalPayFee={finalPayFee}
              roomName={roomName}
              startDate={startDate}
              endDate={endDate}
            />
          )}
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
